import React, { useCallback, useEffect, useReducer } from "react";
import FilterForm from "./partials/FilterForm";
import Table from "./partials/Table";
import { useCookies } from "react-cookie";
import { getMoneyLogHistory } from '../../../controller/api/moneyLogHistory'

export const Context = React.createContext(null);

const initialData = {
  filter: {
    from: new Date(),
    to: new Date(),
    phone: '',
    wallet: 'main',
    page: 0
  },
  data: {
    list: [],
    total: 0,
    totalPage: 0,
    user: null,
    message: ''
  },
  filterPressCount: 0,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SUBMIT_FILTER':
      return {
        ...state,
        filter: {
          ...action.payload,
          page: 0
        },
        filterPressCount: state.filterPressCount + 1
      }
    case 'UPDATE_DATA':
      return {
        ...state,
        data: {
          ...action.payload
        }
      }
    case 'UPDATE_PAGE':
      return {
        ...state,
        filter: {
          ...state.filter,
          page: action.payload
        }
      }
    default:
      return state
  }
}

export default () => {
  const [state, dispatch] = useReducer(reducer, initialData);
  const [cookies] = useCookies(['lottmekong'])

  const getAllFunc = useCallback(async () => {
    const phone = (state.filter.phone || '').trim()
    if (!phone) {
      dispatch({
        type: 'UPDATE_DATA',
        payload: {
          list: [],
          total: 0,
          totalPage: 0,
          user: null,
          message: 'Nhập số điện thoại của một người'
        }
      })
      return
    }

    const response = await getMoneyLogHistory(cookies.lottmekong, {
      from: state.filter.from,
      to: state.filter.to,
      phone,
      wallet: state.filter.wallet,
    }, state.filter.page)

    if (response && response.status === 'fail') {
      dispatch({
        type: 'UPDATE_DATA',
        payload: {
          list: [],
          total: 0,
          totalPage: 0,
          user: null,
          message: response.message || 'Không tải được lịch sử'
        }
      })
      return
    }

    if (response) {
      dispatch({
        type: 'UPDATE_DATA',
        payload: {
          list: response.data || [],
          total: response.total || 0,
          totalPage: response.totalPage || 0,
          user: response.user || null,
          message: ''
        }
      })
    }
  }, [cookies.lottmekong, state.filter.from, state.filter.to, state.filter.page, state.filter.phone, state.filter.wallet])

  useEffect(() => {
    if (state.filterPressCount === 0) {
      return
    }
    getAllFunc()
  }, [getAllFunc, state.filterPressCount, state.filter.page])

  useEffect(() => {
    document.title = "Lịch sử dòng tiền"
  }, []);

  return (
    <Context.Provider value={{
      state,
      dispatch
    }}>
      <FilterForm />
      <br />
      <Table />
    </Context.Provider>
  );
};
